module.exports = __webpack_public_path__ + "static/pitch-83901468d35c4bffbf3000e03ff142fe.gif";